(() => {
  const collectionUrl = document.currentScript.dataset.collectionUrl;
  let availability;

  async function checkAvailability() {
    let next = new URL(collectionUrl, window.location.origin);
    const visited = new Set();
    while (next) {
      next.searchParams.set('section_id', 'nn-food-rescue-availability');
      if (next.origin !== window.location.origin || visited.has(next.href)) throw new Error('Invalid availability page');
      visited.add(next.href);
      const response = await fetch(next.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Availability request failed');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = document.querySelector('[data-nn-food-rescue-result]');
      if (!result) throw new Error('Missing availability result');
      const status = JSON.parse(result.textContent);
      if (typeof status.available !== 'boolean' || (status.next != null && typeof status.next !== 'string')) throw new Error('Invalid availability result');
      if (status.available) return true;
      next = status.next ? new URL(status.next, next) : null;
    }
    return false;
  }

  async function updateNavigation() {
    const entries = [...document.querySelectorAll('[data-nn-food-rescue-pending]')];
    if (!entries.length) return;
    availability ??= checkAvailability().catch(() => {
      availability = undefined;
      return true;
    });
    const available = await availability;
    for (const entry of entries) {
      if (available) entry.removeAttribute('data-nn-food-rescue-pending');
      else entry.remove();
    }
    document.querySelectorAll('[data-nn-scroller]').forEach(scroller => {
      const status = scroller.parentElement.querySelector('[data-nn-slider-status]');
      if (status) {
        const count = scroller.querySelectorAll('.nn-cat-slider__item').length;
        status.textContent = `Slide ${count ? 1 : 0} von ${count}`;
      }
    });
    window.dispatchEvent(new Event('resize'));
  }

  updateNavigation();
  document.addEventListener('shopify:section:load', updateNavigation);
})();
